import { connect } from 'react-redux'
import CrowdfundingDetailView from 'components/crowdfunding_detail_view'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)

  return {
    campaign,
  }
}

export default connect(mapStateToProps)(CrowdfundingDetailView)
